<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Payment Dashboard
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
        </h3>
        <p class="card-subtitle">List of Payments done by the users.</p>
        <vs-row>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-col vs-lg="12" vs-xs="12" class="mb15">
              <vs-select :color="colorx" label="Language Filter" v-model="search.language">
                <vs-select-item value="all" text="All Languages" />
                <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="d-flex drop-width mb15">
              <vs-select :color="colorx" label="Search On" @change="filter($event, 'searchKey')" v-model="search.searchKey">
                <vs-select-item value="" text="Search On" />
                <vs-select-item value="user_id" text="userID" />
                <vs-select-item value="phone" text="Mobile Number" />
                <vs-select-item value="email" text="Email" />
                <vs-select-item value="plan_id" text="PlanID" />
                <vs-select-item value="app_type" text="App Type" />
                <vs-select-item value="device_type" text="Device Type" />
                <vs-select-item value="purchase_type" text="Purchase Type" />
                <vs-select-item value="price" text="Price" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12"
              ><vs-input icon-after="true" label-placeholder="Search by selected parameter" icon="search" v-model="search.searchValue" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button color="primary" type="filled" class="searchBtn" @click="fetchAllPayments()" icon="search">Search</vs-button>
              <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()">Reset</vs-button>
            </vs-col>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <div class="d-flex">
              <vs-input class="mr15" label="Start Date" type="date" v-model="startDate" />
              <vs-input label="End Date" type="date" v-model="endDate" />
            </div>
            <div id="chart">
              <apexchart type="area" ref="chart" height="250" :options="chartOptions" :series="series"></apexchart>
            </div>
            <div class="payments-total-div">
              <p>
                In App :
                {{ this.$data.series[0].data.reduce((acc, current) => acc + current, 0) }}
              </p>
              <p>
                Subscription :
                {{ this.$data.series[1].data.reduce((acc, current) => acc + current, 0) }}
              </p>
              <p>
                Total :
                {{
                  this.$data.series[0].data.reduce((acc, current) => acc + current, 0) +
                  this.$data.series[1].data.reduce((acc, current) => acc + current, 0)
                }}
              </p>
            </div>
          </vs-col>
        </vs-row>
        <br />
        <table class="table mt20">
          <tr>
            <th>#</th>
            <th>User Id / Email / Mobile No</th>
            <th>Plan Id</th>
            <th>App Type</th>
            <th>Language</th>
            <th>Device Type</th>
            <th>Price</th>
            <th @click="sortByDate('date')" style="cursor: pointer">
              Date
              <span v-if="sortByField === 'date'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th>Purchase Type</th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.name">
            <td>
              {{ current_page * data_per_page + index + 1 }}
            </td>
            <td class="td" :style="{ 'word-break': wordBreak }">
              {{ item.user_id || item.email || item.phone }}
            </td>
            <td class="td">{{ item.plan_id }}</td>
            <td class="td">{{ item.app_type }}</td>
            <td class="td">{{ item.language }}</td>
            <td class="td">{{ item.device_type }}</td>
            <td class="td">{{ item.price }}</td>
            <td class="td">{{ moment(item.date) }}</td>
            <td class="td">{{ item.purchase_type }}</td>
          </tr>
        </table>
        <div class="page-button-div">
          <vs-pagination
            :total="page_count"
            v-model="current_page"
            @input="handleCurrentPage"
            :max="maxVisiblePages"
            :prev-text="'Prev'"
            :next-text="'Next'"
          />
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";

export default {
  name: "Payments",
  components: {},
  data: () => ({
    title: "Payments",
    colorx: "#0D2144",
    wordBreak: "break-all",
    sortByField: "",
    sortDirection: "asc",
    defaultalert: false,
    isNew: true,
    search: {
      language: "all",
      searchKey: "",
      searchValue: "",
    },
    all: [],
    startDate: moment.utc(new Date()).startOf("month").format("YYYY-MM-DD"),
    endDate: moment.utc(new Date()).format("YYYY-MM-DD"),
    totalDates: [],
    languages: [],
    series: [
      {
        name: "in_app",
        data: [],
      },
      {
        name: "subscription",
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        height: 250,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "datetime",
        categories: [],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy",
        },
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    total_data: 0,
    data_per_page: 25,
    page_count: 0,
    total_pages_array: [],
    current_page: 1,
    maxVisiblePages: 7,
  }),
  computed: {
    sortedData() {
      if (this.sortByField) {
        return this.all.sort((a, b) => {
          // sort by date
          if (this.sortByField === "date") {
            return this.sortDirection === "asc" ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date);
          }
          return this.all;
        });
      }
    },
    visiblePages() {
      const total = this.page_count;
      const current = this.current_page;
      const max = this.maxVisiblePages;
      if (total <= max) {
        return [...Array(total).keys()];
      }
      let start = Math.max(0, current - Math.floor(max / 2));
      let end = start + max;
      if (end > total) {
        end = total;
        start = end - max;
      }
      return Array.from({ length: end - start }, (_, i) => start + i);
    },
  },
  methods: {
    moment: function (date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },
    sortByDate(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.all = this.sortedData;
    },

    fetchAllPayments() {
      this.$vs.loading();

      api
        .get(API.GET_PAYMENTS, {
          params: {
            page: this.current_page,
            size: this.data_per_page,
            language: this.$data.search.language,
            searchKey: this.$data.search.searchKey,
            searchValue: this.$data.search.searchValue,
          },
        })
        .then((r) => {
          this.$vs.loading.close();
          // sort new date first
          r.data.allPayments.sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
          });

          this.$data.all = r.data.allPayments;

          this.$data.total_data = r.data.totalCount;
          this.$data.page_count = Math.ceil(r.data.totalCount / this.$data.data_per_page);

          this.$data.total_pages_array = [...Array(this.$data.page_count).keys()];

          this.setGraphData(r.data.allPayments);
          this.$refs.chart.refresh();
          if (!r.status) {
            this.$vs.notify({
              title: "Data Not Found",
              text: "No Record Found",
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Could not find the data",
            color: "danger",
            position: "top-right",
          });
        });
      this.setGraphDate();
    },
    setGraphDate() {
      this.$data.chartOptions.xaxis.categories = [];
      var date1 = new Date(this.$data.startDate);
      var date2 = new Date(this.$data.endDate);

      var differenceInTime = date2.getTime() - date1.getTime();
      var differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

      for (var i = 0; i < differenceInDays + 1; i++) {
        // var d = new Date();
        // d.setDate(date1.getDate() + i);
        // console.log(date1.getDate());
        const d = moment(date1).add(i, "day");
        this.$data.chartOptions.xaxis.categories.push(moment.utc(d).format("YYYY-MM-DD"));
      }
    },
    setGraphData(paymentData) {
      this.$data.series[0].data = [];
      this.$data.series[1].data = [];

      this.$data.chartOptions.xaxis.categories.map((date) => {
        const dateMatchedData = paymentData.filter((payment) => moment.utc(payment.date).format("YYYY-MM-DD") === date);
        const inAppPayments = dateMatchedData.filter((p) => p.purchase_type === "in_app");
        const subscriptionPayment = dateMatchedData.filter((p) => p.purchase_type === "subscription");
        if (inAppPayments.length > 0) {
          const sum = inAppPayments.reduce((acc, payment) => acc + payment.price, 0);
          this.$data.series[0].data.push(sum);
        } else {
          this.$data.series[0].data.push(0);
        }
        if (subscriptionPayment.length > 0) {
          const sum = subscriptionPayment.reduce((acc, payment) => acc + payment.price, 0);
          this.$data.series[1].data.push(sum);
        } else {
          this.$data.series[1].data.push(0);
        }
      });
      window.dispatchEvent(new Event("resize"));
    },
    // fetchDataCount() {
    //   this.$vs.loading();
    //   api
    //     .get(API.GET_PAYMENTS_COUNT)
    //     .then((r) => {
    //       this.$vs.loading.close();
    //       this.$data.total_data = r.data;
    //       this.$data.page_count = Math.ceil(
    //         r.data / this.$data.data_per_page
    //       );
    //       this.$data.total_pages_array = [
    //         ...Array(this.$data.page_count).keys(),
    //       ];
    //     })
    //     .catch(() => {
    //       this.$vs.loading.close();
    //     });
    // },
    handleCurrentPage(page) {
      this.$data.current_page = page;
      this.fetchAllPayments();
    },
    handlePrevPage() {
      if (this.current_page > 0) {
        this.handleCurrentPage(this.current_page - 1);
      }
    },
    handleNextPage() {
      if (this.current_page < this.page_count - 1) {
        this.handleCurrentPage(this.current_page + 1);
      }
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    filter(event, param = true) {
      this.$data.search[param] = event;
    },

    resetData() {
      this.$data.search = {
        language: "all",
        searchKey: "",
        searchValue: "",
      };
      this.$data.startDate = moment.utc(new Date()).startOf("month").format("YYYY-MM-DD");
      this.$data.endDate = moment.utc(new Date()).format("YYYY-MM-DD");
      this.fetchAllPayments();
    },
  },

  created() {
    this.fetchAllPayments();
    this.fetchAllLanguages();
    this.setGraphDate();

    if (!this.$data.search.language) {
      this.$data.search.language = "all";
    }
  },
};
</script>

<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  /* margin-top: 25px; */
  margin-top: 10px;
  margin-right: 8px;
  width: 30%;
}

.payments-total-div {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.payments-total-div p {
  font-weight: 700;
}

.page-button-div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 10px !important;
}

.pagination-button {
  background-color: transparent !important;
  border: 1px solid rgba(121, 121, 125, 0.326);
  color: black;
}

.clicked {
  background-color: rgba(0, 0, 205, 0.768) !important;
  border: 1px solid rgba(0, 0, 205, 0.768);
  color: white;
  font-weight: 700;
}

.display-none {
  display: none;
}
</style>
